import salesReqs from './salesReqs.js'
import salesReqItems from './salesReqItems.js'

// export config.models
export default {
  models: {
    salesReqs: {
      ...salesReqs,
      views: {
        main: {
          options: {
            skus: {},
          },
        },
      },
    },
    salesReqItems,
  },
}
